import { render, staticRenderFns } from "./report-tongue80.vue?vue&type=template&id=5df58466&scoped=true"
import script from "./report-tongue80.vue?vue&type=script&lang=ts"
export * from "./report-tongue80.vue?vue&type=script&lang=ts"
import style0 from "./report-tongue80.vue?vue&type=style&index=0&id=5df58466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df58466",
  null
  
)

export default component.exports